import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import DeleteCoupons from '@/models/Coupon/DeleteCoupons';
import UpdateCoupon from '@/models/Coupon/UpdateCoupon';
import CreateCoupon from '@/models/Coupon/CreateCoupon';


const resource = '/coupons';

export default {
  fetchCoupons(listRequest: ListRequest) {
    return Repository.post(`${resource}/listcoupons`, listRequest, { withCredentials: true });
  },
  createCoupon(createCoupon: CreateCoupon) {
    return Repository.post(`${resource}/createcoupon`, createCoupon, { withCredentials: true });
  },
  updateCoupon(updateCoupon: UpdateCoupon) {
    return Repository.post(`${resource}/updatecoupon`, updateCoupon, { withCredentials: true });
  },
  deleteCoupons(deleteCoupon: DeleteCoupons) {
    return Repository.post(`${resource}/deletecoupons`, deleteCoupon, { withCredentials: true });
  },
  checkCoupon(couponCode: string) {
    return Repository.post(`${resource}/RedeemCoupon`, { couponCode }, { withCredentials: true });
  }
};
